export default "__VITE_ASSET__CJRe7$oZ__"